import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

const PKG_KEY = ["hour-packages"];

function useHourPackages() {
  return useQuery({
    queryKey: PKG_KEY,
    queryFn: () => apiClient.get("/api/v1/hour-packages/").then((r) => r.data),
  });
}

function useCreateHourPackage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      apiClient.post("/api/v1/hour-packages/", body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: PKG_KEY }),
  });
}

function useUpdateHourPackage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      apiClient
        .patch(`/api/v1/hour-packages/${id}/`, body)
        .then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: PKG_KEY }),
  });
}

function useDeleteHourPackage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiClient.delete(`/api/v1/hour-packages/${id}/`),
    onSuccess: () => qc.invalidateQueries({ queryKey: PKG_KEY }),
  });
}

export {
  useHourPackages,
  useCreateHourPackage,
  useUpdateHourPackage,
  useDeleteHourPackage,
  PKG_KEY,
};
